import React from 'react';
import { Melt } from './Melt';
import texts from './data.js';

export const MeltCanvas = () => {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        {/* <Melt 
          colors={[ 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'blue', 'black', 'black', 'blue', 'black', 'black',]}
          strokeWidth={ 1 }
          startingStrokeCounter={ 1 }
          strokeIncrement={0.01}
          segments={500}
          methodX={ x => Math.tan(x) }
          methodY={ y => Math.cos(y) }
          texts = {texts[0]}
        /> */}
        <Melt 
          colors={[ 'pink', 'pink', 'pink', 'white', 'pink', 'pink', 'pink', 'white', 'pink', 'pink', 'pink', ]}
          texts={texts[0]}
          segments={1000}
          strokeWidth={ 10 }
          documentBackgroundColor={'#53DD6C'}
        />
        <Melt 
          bend={200}
          colors={['#53DD6C', 'yellow', '#53DD6C', 'yellow', '#53DD6C', '#53DD6C', '#53DD6C', ]}
          texts = {texts[1]}
          segments={1000}
          documentBackgroundColor={'pink'}
          fillColor={'blue'}
        />
        <Melt 
          startingStrokeCounter={ 50 }
          bend={-200}
          colors={['orange', 'rgba(0,0,255,0.05)', 'rgba(255,255,0,0.5)',  ]}
          strokeWidth={50}
          segments={1000}
          strokeIncrement={-0.001}
          texts={texts[2]}
          documentBackgroundColor={'silver'}
        />
        <Melt 
          startingStrokeCounter={ 100 }
          bend={100}
          colors={['lightgreen', 'green', 'rgba(255,0,0,0.15)', '#53DD6C', '#53DD6C', 'rgba(255,0,0,0.15)', 'rgba(255,0,0,0.15)','rgba(255,0,0,0.5)','rgba(255,0,0,0.5)','rgba(255,0,0,0.5)','rgba(255,0,0,0.5)', ]}
          strokeWidth={10}
          segments={1000}
          strokeIncrement={0.001}
          texts={texts[3]}
          documentBackgroundColor={'orange'}
          fillColor={'pink'}
        />
        {/* <Melt 
          startingStrokeCounter={ 1 }
          colors={['red', 'pink', 'violet'  ]}
          methodX={ x => Math.log(x) }
          methodY={ y => Math.PI * Math.sin(y) }
        />
        <Melt 
          startingStrokeCounter={ 1 }
          strokeIncrement={0}
          colors={['red', 'pink', 'violet'  ]}
          methodY={ y => Math.PI * Math.sin(y) }
        /> */}
      </div>
    );
  };
  export default MeltCanvas;